import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { config } from '../config/pages-config';

const routes: Routes = [
    {
        path: '',
        redirectTo: config.landingPage.route,
        pathMatch: 'full',
    },
    {
        //  overview module
        path: config.overview.name,
        loadChildren: () => import('./order-overview/order-overview.module').then(m => m.OverviewModule),
    },
    {
        // Revocation
        path: config.revocation.name,
        loadChildren: () => import('./revocation/revocation.module').then(m => m.RevocationModule),
    },
    {
        //  Service Agent
        path: config.serviceAgent.name,
        loadChildren: () => import('./service-agent/service-agent.module').then(m => m.ServiceAgentModule),
    },
    {
        //  SIM & Hardware Revocation
        path: config.salesAgent.name,
        loadChildren: () => import('./sales-agent/sales-agent.module').then(m => m.SalesAgentModule),
    },
    {
        // Confirmation
        path: config.confirmation.name,
        loadChildren: () => import('./confirmation/confirmation.module').then(m => m.ConfirmationModule),
    },
    {
        // Winback page
        path: config.winback.name,
        loadChildren: () => import('./winback/winback.module').then(m => m.WinbackModule),

    },
    {
        // open-questions page
        path: config.openQuestions.name,
        loadChildren: () => import('./open-questions/open-questions.module').then(m => m.OpenQuestionsModule),
    },
    {
        // general error handleing page
        path: config.generalError.name,
        loadComponent: () => import('./shared/shared-components/general-error/general-error.component').then(comp => comp.GeneralErrorComponent),
        pathMatch: 'full',
    },
    {
        // Unauthorized
        path: config.unauthorized.name,
        loadComponent: () => import('./shared/shared-components/unauthorized/unauthorized.component').then(comp => comp.UnauthorizedComponent),
        pathMatch: 'full',
    },
    {
        //  review module
        path: config.review.name,
        loadChildren: () => import('./review/review.module').then(m => m.ReviewModule),
    },
    {
        //  defect module
        path: config.defect.name,
        loadChildren: () => import('./defect/defect.module').then(m => m.DefectModule),
    },
    {
        //  second delivery module
        path: config.secondDelivery.name,
        loadChildren: () => import('./second-delivery/second-delivery.module').then(m => m.SecondDeliveryModule),
    },
    {
        //   cancel contract module
        path: config.cancelContract.name,
        loadChildren: () => import('./cancel-contract/cancel-contract.module').then(m => m.CancelContractModule),
    },
    {
        //  termination
        path: config.termination.name,
        loadChildren: () => import('./termination/termination.module').then((m) => m.TerminationModule),
    },
    {
        //  revocation KD
        path: config.revokationKD.name,
        loadChildren: () => import('./revocation-extension/revocation-extension.module').then((m) => m.revocationExtensionModule),
    },
    {
        // landingPage module
        path: config.landingPage.name,
        loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
    },
    {
        // returnDevices
        path: config.returnDevices.name,
        loadChildren: () => import('./return-devices/return-devices.module').then(comp => comp.ReturnDevicesModule),
    },
    {
        path: '**',
        loadComponent: () => import('./shared/shared-components/fallback-routes/fallback-routes.component').then(comp => comp.FallbackRoutesComponent),
    },

];
/** AppRoutingModule */
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false })],
    exports: [RouterModule],
})

export class AppRoutingModule { }
